module.exports = __webpack_public_path__ + "static/media/handbook_confirmation_image.d06fd18c.png";